import { render, staticRenderFns } from "./ApolloQuery.vue?vue&type=template&id=4a98114e&"
import script from "./ApolloQuery.vue?vue&type=script&lang=js&"
export * from "./ApolloQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports